import MuiDrawer from '@mui/material/Drawer'
import Stack from '@mui/material/Stack'
import React from 'react'
import { Scrollbar } from 'ui/scrollbar/Scrollbar'
import { ReactComponent as CrossCloseLogo } from '../../assets/cross_close_logo.svg'
import { COLORS } from '../../styles/colors'
import { TypographyHeader } from '../typography/TypographyHeader'

interface DrawerProps {
	open: boolean
	onClose: () => void
	title: string
	width?: number | string
	anchor?: 'right' | 'left'
	children: React.ReactNode
	headerActions?: React.ReactNode
	transitionDuration?: number | { enter: number; exit: number }
	closeAboveTitle?: boolean
}

const Drawer: React.FC<DrawerProps> = ({
	open,
	onClose,
	title,
	width = 500,
	anchor = 'right',
	transitionDuration = 300,
	headerActions,
	closeAboveTitle = false,
	children,
}: DrawerProps) => {
	const handleClose = () => {
		onClose()
	}

	return (
		<MuiDrawer
			anchor={anchor}
			open={open}
			onClose={handleClose}
			transitionDuration={transitionDuration}
			PaperProps={{
				sx: {
					borderRadius: anchor === 'right' ? '12px 0 0 12px' : '0 12px 12px 0',
					height: '100%',
				},
			}}
		>
			<Stack
				sx={{
					width,
					height: '100%',
				}}
				gap={'24px'}
			>
				{closeAboveTitle ? (
					<Stack pt='24px' px='24px' gap='8px'>
						<Stack direction='row' justifyContent='flex-end' gap='8px'>
							{headerActions}
							<CrossCloseLogo
								onClick={handleClose}
								style={{ cursor: 'pointer', stroke: COLORS.icon }}
							/>
						</Stack>
						<TypographyHeader>{title}</TypographyHeader>
					</Stack>
				) : (
					<Stack
						display='flex'
						direction='row'
						alignItems='center'
						justifyContent='space-between'
						pt={'40px'}
						px={'24px'}
					>
						<TypographyHeader>{title}</TypographyHeader>
						<Stack direction='row' alignItems='center' gap='8px'>
							{headerActions}
							<CrossCloseLogo
								onClick={handleClose}
								style={{ cursor: 'pointer', stroke: COLORS.icon }}
							/>
						</Stack>
					</Stack>
				)}
				<Scrollbar
					sx={{
						flex: 1,
						minHeight: 0,
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					{children}
				</Scrollbar>
			</Stack>
		</MuiDrawer>
	)
}

export default Drawer
